import { combineReducers, configureStore } from "@reduxjs/toolkit";
import UserReducer from "./user/UserSlice"
import EdiReducer from "./edi/EdiSlice"
import { persistReducer, persistStore } from 'redux-persist';
import createWebStorage from "redux-persist/lib/storage/createWebStorage";

const storage = createWebStorage('local')

const persistConfig = {
    key: 'root',
    storage,
};

const persistedReducer = persistReducer(
    persistConfig,
    combineReducers({
        user: UserReducer,
        edi: EdiReducer,
    })
)

export const store = configureStore({
    reducer: persistedReducer
})

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;